import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarLightReachDto } from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The LightReach step's one read: the stored offers against today's pricing,
 * the selected offer and its freshness, the applications, the contract and
 * what the viewer may do. Reading never calls LightReach; the commands answer
 * with this read.
 */
export default function useSolarLightReach(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SolarLightReachDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.lightReach(proposalId ?? ``),
    queryFn: () => solarProposalService.getLightReach(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
